import React from "react";
import AttendanceWidget from "./AttendanceWidget";
import Loading from "../../../Loading";
import MonthChoice from "../../../components/MonthChoice";
import HtClass from "../../../components/HtClass";
import Lang from "../../../components/Lang";
import sdate from "../../../../../sdate.ts";
import DateChoice from "../../../components/DateChoice";
import IconButtonHT from "../../../components/IconButtonHT.tsx";
import AddMakeupDialog from "./AddMakeupDialog.tsx";
import useDBO from "../../../hooks/useDBO.ts";


export default function Attendance(props) {
  const { student } = props;
  const [year, setYear] = React.useState(new Date().getFullYear());
  const [month, setMonth] = React.useState(new Date().getMonth());
  const [countDate,setCountDate] = React.useState("")
  const attendance = useDBO(
    `/students/${student._id}/attendance`
  );
  const [openMakeupDialog, setOpenMakedDialog] = React.useState(false)

/*   React.useEffect(() => {
    net
      .get()
      .then((res) => setAttendance((prev) => res));
  }, [student]); */

  if (attendance.loading) return <Loading />;

  let atThisMonth = attendance.filter((a) => new sdate(a.classDate).year() === year && new sdate(a.classDate).month() === month+1);

  let htClassIds = [...new Set(atThisMonth.map((at) => at.htClass))];

  return (
    <div>
      <div
        style={{ display: "flex", justifyContent: "space-between", margin: 10 }}
      >
        <div className="attendance-title flex items-center gap-5">
          <h3>
            <Lang w="attendance" />
          </h3>

          <div className="flex items-center gap-5">
            <DateChoice
              value={countDate}
              setValue={setCountDate}
              label="Count attendances"
            />
            {countDate && <CountAttendances
              attendance={attendance.filter((at) => at.tDate >= countDate)}
            />}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <MonthChoice
            month={month}
            setMonth={setMonth}
            year={year}
            setYear={setYear}
          />
        </div>
      </div>

      {htClassIds.map((htClass) => (
        <div
          key={htClass}
          className="attendance-class"
        >
          <div className="attendance-class-title">
            <HtClass htClass={htClass} /> (
            {atThisMonth.filter((a) => a.htClass === htClass).length})
          </div>
          <div className="attendance-widgets-layout items-center">
            {atThisMonth
              .filter((a) => a.htClass === htClass)
              .sort((a,b) => (a.classDate > b.classDate) ? 1 : ((b.classDate > a.classDate) ? -1 : 0))
              .map((attendance) => (
                <AttendanceWidget
                  key={`attendance${attendance._id}`}
                  attendance={attendance}
                />
              ))}
            <div>
              <IconButtonHT icon="add" color="green" toolTip="Add makeup class" onClick={()=>setOpenMakedDialog(true)}/>
              <AddMakeupDialog open={openMakeupDialog} setOpen={setOpenMakedDialog} student={student} htClass={htClass} add={attendance.add} />
             </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function CountAttendances({ attendance }) {
  return (
    <div>
      Attended: {attendance.filter((at) => at.attendance < 2).length}, {" "}
      Absent: {attendance.filter((at) => at.attendance === 2).length}, {" "}
      No Show: {attendance.filter((at) => at.attendance === 3).length}, {" "}
      Total attended or No show:{" "}
      {attendance.filter((at) => at.attendance < 2).length +
      attendance.filter((at) => at.attendance === 3).length}
    </div>
  );
}